import { render, staticRenderFns } from "./CommuteScene.vue?vue&type=template&id=36a0c074&scoped=true&lang=pug&"
import script from "./CommuteScene.vue?vue&type=script&lang=js&"
export * from "./CommuteScene.vue?vue&type=script&lang=js&"
import style0 from "./CommuteScene.vue?vue&type=style&index=0&id=36a0c074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a0c074",
  null
  
)

export default component.exports